import validations from "../../api/validations";
import router from "../../router";

const state = () => ({
  loading: {
    validations: false,
    validation: false,
  },
  all: [],
  total: undefined,
  current: undefined,
});

// actions
const actions = {
  async submitValidationAsync(
    { commit, dispatch },
    { _id, validator, next, status, reason }
  ) {
    try {
      const { data: updated } = await validations.updateValidation(
        _id,
        validator,
        next,
        status,
        reason
      );
      if (router.currentRoute.name === "Orders Details") {
        commit("orders/SET_ORDER", updated, { root: true });
        commit("orders/SET_ORDERS", updated, { root: true });
      } else {
        commit("orders/SET_ORDER", updated, { root: true });
        commit("SET_VALIDATION", updated);
        commit("SET_VALIDATIONS", updated);
      }
      dispatch("snackbar/showSuccess", "Validation mise à jour", {
        root: true,
      });
      dispatch("dialog/closeDialog", "validation", { root: true });
      dispatch("dialog/closeDialog", "accept", { root: true });
      dispatch("dialog/closeDialog", "reject", { root: true });
    } catch (error) {
      console.log(error);
      dispatch("snackbar/showError", error.message, { root: true });
    }
  },
  async loadValidations({ dispatch, commit }) {
    commit("SET_LOADING", ["validations", true]);
    try {
      commit("ADD_VALIDATIONS", await validations.getValidations());
      commit("SET_LOADING", ["validations", false]);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_LOADING", ["validations", false]);
    }
  },
  async loadValidation({ dispatch, commit }, _id) {
    commit("SET_LOADING", ["validation", true]);
    try {
      const { data: validation } = await validations.getValidation(_id);
      commit("orders/SET_ORDER", validation, { root: true });
      commit("SET_LOADING", ["validation", false]);
    } catch (error) {
      dispatch("snackbar/showError", error.message, { root: true });
      commit("SET_LOADING", ["validation", false]);
    }
  },
};

// mutations
const mutations = {
  ADD_VALIDATIONS(state, { data }) {
    state.all = data.docs;
    state.total = data.totalDocs;
  },
  SET_LOADING(state, [type, loading]) {
    state.loading[type] = loading;
  },
  SET_VALIDATIONS(state, validation) {
    Object.assign(
      state.all.find((o) => o._id === validation._id),
      validation
    );
  },
};

export default { namespaced: true, state, actions, mutations };
